import React from "react";
import { Helmet } from "react-helmet";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/September-2026/banner.jpeg";
import sharpeningLeadTargetingRealEstateDeveloper from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Sharpening-Lead-Targeting-for-a-Leading-Real-Estate-Developer.jpg";
import strengtheningB2BMarketingAdhesiveManufacturer from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Strengthening-B2B-Marketing-for-a-Leading-Adhesive-Manufacturer.jpg";
import sushil from "../../assets/images/Newsletter/images/shushil-Gujrathi.png";
import BringingCustomer360ViewJewelleryBrand from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Bringing-a-Customer-360-View-to-the-Store-Floor-for-an-Established-Jewellery-Brand.jpg";
import buildingUnifiedDataFoundationPublicTransportationProvider from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Building-a-Unified-Data-Foundation-for-a-Public-Transportation-Provider.jpg";
import partneringSalesServiceImplementation from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Partnering-on-Sales-and-Service-Implementation.jpg";
import buildingCitizen360ViewStateGovernment from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Building-a-Citizen-360-View-for-a-State-Government.jpg";
import nehaKushwaha from "../../assets/images/Newsletter/September-2026/neha-kushwaha.jpg";
import satyaNadella from "../../assets/images/Newsletter/September-2026/satya-nadella.jpg";
import idmaBestDigitalInnovationAward from "../../assets/images/Newsletter/September-2026/Awards and Recognition/idma-2026-best-digital-innovation-award.jpg";
import etMartechGoldTrophies from "../../assets/images/Newsletter/September-2026/Awards and Recognition/et-martech-2026-gold-trophies.jpg";
import etMartechGoldWinner from "../../assets/images/Newsletter/September-2026/Awards and Recognition/et-martech-2026-gold-awards-winner.jpg";
import newJoinersQ2 from "../../assets/images/Newsletter/September-2026/New-Joinees.jpeg";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import nuturingNewCustomersLeadingFoodCompany from "../../assets/images/Newsletter/September-2026/Our Latest Wins/nuturing-New-Customers-Leading-Food-Company.jpg";
import optimizingMigrationAzureBusinessGroup from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Optimizing-a-Migration-to-Azur.jpg";
import poweringFestiveCampaignsJewelleryBrand from "../../assets/images/Newsletter/September-2026/Our Latest Wins/Powering-Festive-Campaigns-for-a-Leading-Jewellery-Brand.jpg";
import dreamforce2026Arch from "../../assets/images/Newsletter/September-2026/Comsense in Action/dreamforce-2026-1.jpg";
import dreamforce2026Team from "../../assets/images/Newsletter/September-2026/Comsense in Action/dreamforce-2026-2.jpg";
import dreamforce2026Selfie from "../../assets/images/Newsletter/September-2026/Comsense in Action/dreamforce-2026-3.jpg";
import agentforceFdeReadyPractitionerWorkshop from "../../assets/images/Newsletter/September-2026/Comsense in Action/agentforce-fde-ready-practitioner-workshop.png";
import annualDay from "../../assets/images/Newsletter/September-2026/Events & Celebrations/annual-day.jpg";
import annualDayTeam from "../../assets/images/Newsletter/September-2026/Events & Celebrations/annual-day-team.jpg";

import independenceDayCelebrations from "../../assets/images/Newsletter/September-2026/Events & Celebrations/decoration.jpg";
import independenceDayCelebrationstwo from "../../assets/images/Newsletter/September-2026/Events & Celebrations/flag.jpg";

import grandBirthdayCelebrations1 from "../../assets/images/Newsletter/September-2026/Events & Celebrations/Sep-2026-Bday.jpg";
import grandBirthdayCelebrations2 from "../../assets/images/Newsletter/September-2026/Events & Celebrations/Jul-2026-bday.jpg";
import spiritualCornerChariji from "../../assets/images/Newsletter/September-2026/Daaji.jpg";
import azimPremji from "../../assets/images/Newsletter/September-2026/Azim_H_Premji.jpg";
import sayliAtkare from "../../assets/images/Newsletter/September-2026/Sayli-Atkare.jpeg";
import sonyPetkar from "../../assets/images/Newsletter/September-2026/Sony-Petkar.jpeg";
import indraNooyi from "../../assets/images/Newsletter/September-2026/IndraNooyi.jpg";

import ganpatiCelebrations from "../../assets/images/Newsletter/September-2026/Events & Celebrations/Ganpati-Chaturthi.jpg";
import ganpatiCelebrationsPeople from "../../assets/images/Newsletter/September-2026/Events & Celebrations/Celebrating-Ganpati-Chaturthi.jpg";


const September2026 = () => {
  return (
    <>
      <Helmet>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        {/* <meta
          property="og:image"
          content="https://www.comsensetechnologies.com/static/media/banner.6e975f755f10acaff87f.png"
        /> */}

        <title>COMSENSE - NEWSLETTER September-2026</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />


        <meta property="og:title" content="September 2026 Newsletter - Comsense Technologies" />
        <meta property="og:description" content="Explore Comsense September 2026 newsletter updates, events, and insights." />
        <meta property="og:image" content="https://www.comsensetechnologies.com/static/media/banner.ac0830962a588290d218.png" />
        <meta property="og:url" content="https://www.comsensetechnologies.com/newsletter/september-2026" />
        <meta property="og:type" content="article" />

        {/* VERY IMPORTANT */}
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* WhatsApp / Twitter support */}
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <>
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      .quote-card-row {\n        display: block !important;\n      }\n\n      .quote-card-text {\n        display: block !important;\n        width: 100% !important;\n        text-align: center !important;\n      }\n\n      .quote-card-gutter {\n        display: none !important;\n      }\n\n      .quote-card-image {\n        display: block !important;\n        width: 100% !important;\n        text-align: center !important;\n        padding-top: 16px !important;\n      }\n\n      .quote-card-image img {\n        margin: 0 auto !important;\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    
                
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sushil}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From The CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                From High Performance to Higher
                                                Impact
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Team,
                                              <br />
                                              <br />
                                              As we close Q3 2026, I am
                                              encouraged by how our strategy
                                              is translating into tangible
                                              business outcomes.
                                              <br />
                                              <br />
                                              We began the year with{" "}
                                              <strong>From Hustle to Harmony</strong>{" "}
                                              bringing greater alignment
                                              across People, Customer, Process
                                              and Technology. In Q2, we
                                              focused on turning that
                                              alignment into performance. Q3
                                              has been about taking the next
                                              step: converting performance
                                              into customer impact, stronger
                                              relationships and sustainable
                                              growth.
                                              <br />
                                              <br />
                                              <strong>Progress That Matters</strong>
                                              <br />
                                              This quarter, several outcomes
                                              reinforce that we are moving in
                                              the right direction:
                                              <br />
                                              • <strong>100% extension</strong>{" "}
                                              of our existing renewals, a
                                              strong reflection of customer
                                              trust and the value our teams
                                              continue to deliver.
                                              <br />
                                              • <strong>New Salesforce logos</strong>{" "}
                                              added, expanding our customer
                                              base and strengthening our
                                              position within the Salesforce
                                              ecosystem.
                                              <br />
                                              • <strong>Deeper engagements</strong>{" "}
                                              with existing customers, with
                                              conversations increasingly
                                              moving beyond execution towards
                                              Data, AI, Salesforce and
                                              transformation-led
                                              opportunities.
                                              <br />
                                              • <strong>
                                                Continued expansion of our AI
                                                capabilities
                                              </strong>{" "}
                                              and accelerators, embedding AI
                                              into delivery, sales, consulting
                                              and internal productivity.
                                              <br />
                                              <br />
                                              These are important business
                                              KPIs, but what matters equally is
                                              what they represent: customer
                                              confidence, stronger capabilities
                                              and our ability to create value
                                              beyond individual projects.
                                              <br />
                                              <br />
                                              <strong>
                                                Customer Value → Business Growth
                                              </strong>
                                              <br />
                                              Our 100% renewal/extension
                                              performance is particularly
                                              significant. Retention is not
                                              simply a commercial metric—it is
                                              one of the strongest validations
                                              of customer experience and
                                              delivery quality.
                                              <br />
                                              Our next
                                              opportunity is to build on that
                                              trust. We need to deepen key
                                              accounts, identify new problems
                                              we can solve, and bring the
                                              combined power of{" "}
                                              <strong>
                                                Data, AI, Salesforce,
                                                Engineering and Consulting
                                              </strong>{" "}
                                              to every strategic relationship.
                                              <br />
                                              <br />
                                              <strong>
                                                Building an AI-First
                                                Organization
                                              </strong>
                                              <br />
                                              AI continues to move from
                                              experimentation to execution. Our
                                              focus is increasingly on applying
                                              AI where it can create measurable
                                              outcomes: faster delivery, higher
                                              productivity, better customer
                                              experiences and differentiated
                                              solutions. The ambition remains
                                              unchanged: AI should not be
                                              another capability at Comsense;
                                              it should become part of how we
                                              think, sell, build and deliver.
                                              <br />
                                              <br />
                                              <strong>The Final Quarter</strong>
                                              <br />
                                              As we enter Q4, our priorities
                                              are clear: deepen strategic
                                              customer relationships,
                                              accelerate our Data & AI
                                              capabilities, strengthen our
                                              Salesforce proposition, expand
                                              our presence across markets and
                                              GCC/expansion opportunities, and
                                              continue building a predictable
                                              and profitable growth engine. The
                                              opportunity ahead is significant,
                                              but so is the responsibility to
                                              execute. Our next phase will be
                                              defined not by how much we do,
                                              but by the impact we create, the
                                              value we deliver, and how
                                              consistently we can scale it.
                                              <br />
                                              <br />
                                              Our journey this year has been
                                              deliberate:
                                              <br />
                                              <strong>
                                                Harmony → Performance → Impact →
                                                Sustainable Growth.
                                              </strong>
                                              <br />
                                              <br />
                                              <strong>Thank You</strong>
                                              <br />
                                              To our teams for the ownership
                                              and commitment behind every
                                              customer success and renewal.
                                              <br />
                                              To our clients for your continued
                                              trust and for giving us the
                                              opportunity to do more together.
                                              <br />
                                              To our partners for helping us
                                              expand our capabilities and
                                              reach.
                                              <br />
                                              <br />
                                              The strongest measure of our
                                              progress is not how busy we are,
                                              but the customers who stay with
                                              us, the new customers who choose
                                              us, and the value we create for
                                              them.
                                              <br />
                                              <br />
                                              Let us carry this momentum into
                                              Q4 and finish 2026 stronger than
                                              we started.
                                              <br />
                                              <br />
                                              <strong>Sushil Gujrathi</strong>
                                              <br />
                                              <strong>
                                                Co-Founder & CEO
                                              </strong>
                                              <br />
                                              <strong>
                                                Comsense Technologies
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Our Latest Wins:
                                            </singleline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                  
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Sharpening Lead Targeting for a Leading Real Estate Developer
                                                  </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={sharpeningLeadTargetingRealEstateDeveloper}
                                              alt="Sharpening Lead Targeting for a Leading Real Estate Developer"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
As part of our Managed Services engagement, Comsense has implemented booking prediction and site visit models on Salesforce Data Cloud and Marketing Cloud, with campaigns activated across multiple channels. We are building a Hybrid Score and a Dashboard that will give insights from customer interactions and help them score leads for more focused targeting. 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Strengthening B2B Marketing for a Leading Adhesive Manufacturer 
                                                </strong>

                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={strengtheningB2BMarketingAdhesiveManufacturer}
                                              alt="strengthening B2B Marketing for a Leading Adhesive Manufacturer"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense has secured the Data Cloud and Marketing Cloud Managed Services engagement for the year with a leading adhesive manufacturer. The engagement focuses on B2B marketing, helping the company engage with its business audiences across channels. The partnership has also expanded to support campaigns for the company’s new product lines. 

 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Building a Unified Data Foundation for a Public Transportation Provider  
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={buildingUnifiedDataFoundationPublicTransportationProvider}
                                              alt="Building a Unified Data Foundation for a Public Transportation Provider"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense is helping a public transportation provider move from fragmented and largely manual reporting to a scalable, integrated and data-driven operational ecosystem. The initiative brings data from multiple operational and enterprise systems into a centralized Data Lake and Analytics Platform, creating a unified foundation for enterprise-wide visibility and AI/ML use cases.
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Bringing a Customer 360 View to the Store Floor for an Established Jewellery Brand 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={BringingCustomer360ViewJewelleryBrand}
                                              alt="Bringing a Customer 360 View to the Store Floor for an Established Jewellery Brand"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense has established a new engagement with an established jewellery brand in Madhya Pradesh, securing Data Cloud, Marketing Cloud and Store Intelligence. The Store Intelligence solution will help sales teams better understand customers walking into their stores by providing richer context through a unified Customer 360 view.

 
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Partnering on Sales and Service Implementation with a Leading Tech Services Provider 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={partneringSalesServiceImplementation}
                                              alt="Partnering on Sales and Service Implementation with a Leading Tech Services Provider"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense is partnering with a leading DevOps and release management platform provider to implement Salesforce Sales Cloud and Service Cloud solutions. The engagement supports the team across the implementation lifecycle, from planning through to delivery, helping streamline sales and service processes, improve visibility across customer interactions, and establish a more connected approach to managing customer relationships.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Building a Citizen 360 View for a State Government 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={buildingCitizen360ViewStateGovernment}
                                              alt="Building a Citizen 360 View for a State Government"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                     Comsense supported the implementation of Salesforce Data Cloud for a state government, building a Citizen 360 view that brings citizen information together in one place. The solution gives visibility into whether citizens have availed of government schemes, helping teams see where schemes are reaching people and where they are not. 
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Nurturing New Customers for a Leading Food Company 
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={nuturingNewCustomersLeadingFoodCompany}
                                              alt="Nurturing New Customers for a Leading Food Company"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense has implemented Salesforce Marketing Cloud channels for a leading food company, helping the business nurture its new customers through timely and relevant communication from their very first interactions. 
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Optimizing a Migration to Azure for a Leading Business Group
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={optimizingMigrationAzureBusinessGroup}
                                              alt="Optimizing a Migration to Azure for a Leading Business Group"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense is supporting a leading business group as it migrates its web environment from on-premise infrastructure to Microsoft Azure. The focus is on making sure every integration is optimized, so the move to the cloud is smooth and the experience stays reliable.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
Powering Festive Campaigns for a Leading Jewellery Brand
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={poweringFestiveCampaignsJewelleryBrand}
                                              alt="Powering Festive Campaigns for a Leading Jewellery Brand"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
Comsense has been selected to run festive campaigns for a leading jewellery brand using Salesforce Marketing Cloud and Data Cloud. Bringing a consultative lens shaped by our experience in the jewellery space, we will help the brand get the most out of the festive season.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>


   <tr>
                                  <td height={20} />
                                </tr>


                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

    <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Our industry does not respect tradition. What it respects is innovation.”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Satya Nadella (Chairman & CEO, Microsoft)
                                                        </span>{" "}
                                                       
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={satyaNadella}
                                                      alt="Satya Nadella, Chairman & CEO of Microsoft"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={15} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>



          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Comsense in Action
                                            </singleline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>Comsense at Dreamforce 2026</strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                    <td
                                                      width="33%"
                                                      style={{ lineHeight: 0, paddingRight: 6 }}
                                                    >
                                                      <img
                                                        src={dreamforce2026Arch}
                                                        alt="Dreamforce 2026 entrance arch in San Francisco"
                                                        style={{
                                                          display: "block",
                                                          border: 0,
                                                          width: "100%",
                                                          height: 170,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                    </td>
                                                    <td
                                                      width="33%"
                                                      style={{ lineHeight: 0, paddingRight: 6 }}
                                                    >
                                                      <img
                                                        src={dreamforce2026Team}
                                                        alt="Comsense team members at Dreamforce 2026"
                                                        style={{
                                                          display: "block",
                                                          border: 0,
                                                          width: "100%",
                                                          height: 170,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                    </td>
                                                    <td
                                                      width="33%"
                                                      style={{ lineHeight: 0 }}
                                                    >
                                                      <img
                                                        src={dreamforce2026Selfie}
                                                        alt="The Comsense team with peers at Dreamforce 2026"
                                                        style={{
                                                          display: "block",
                                                          border: 0,
                                                          width: "100%",
                                                          height: 170,
                                                          objectFit: "cover",
                                                        }}
                                                      />
                                                    </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                The Comsense team attended Dreamforce 2026 in San Francisco,
                                                joining customers, partners, and leaders from across the
                                                Salesforce ecosystem.
                                                <br />
                                                <br />
                                                Over three days, the team exchanged perspectives on current
                                                customer priorities and the ways organisations are bringing
                                                Salesforce, data and AI together. It was a meaningful view of
                                                the developments shaping the Salesforce landscape as businesses
                                                advance their digital transformation journeys.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                   
                                    
                                        <tr>
                                          <td height={40} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Team Completes Agentforce FDE Ready
                                                  Practitioner Workshop
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={agentforceFdeReadyPractitionerWorkshop}
                                              alt="Agentforce FDE Ready Practitioner, FDE Ready Foundation and Implementation Ready workshop badges"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense team successfully completed the Agentforce FDE Ready
                                                Practitioner Workshop, strengthening its understanding of
                                                Salesforce’s AI-powered CRM capabilities and their application in
                                                enterprise environments.
                                                <br />
                                                <br />
                                                The workshop provided hands-on exposure to Agentforce and helped
                                                the team build practical knowledge around designing and working
                                                with AI-powered customer experiences. This adds to Comsense’s
                                                capabilities in supporting organisations as they explore and
                                                implement Agentforce as part of their broader CRM and customer
                                                engagement strategies.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


          {/* Awards and Recognitions */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Awards and Recognitions
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense wins the Best Digital Innovation Award at
                                            IDMA 2026
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "70%",
                                                margin: "0 auto",
                                              }}
                                              src={idmaBestDigitalInnovationAward}
                                              alt="Comsense Technologies receiving the Best Digital Innovation Award at IDMA 2026 for the Weather API Campaign with Royal Enfield"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense Technologies has won Best Digital Innovation Award
                                              at the Indian Digital Marketing Awards (IDMA) 2026 by{" "}
                                              <strong>exchange4media</strong> for our Weather API Campaign
                                              with Royal Enfield.
                                              <br />
                                              The campaign brought real-time weather data into digital
                                              consumer touchpoints, enabling Royal Enfield to deliver more
                                              contextual and relevant experiences based on the riders’
                                              real-time environments.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense wins two Gold awards at ET Martech+ 2026
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "300px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={etMartechGoldTrophies}
                                                      alt="Two ET Martech+ 2026 Gold award trophies won by Royal Enfield and Comsense Technologies"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "300px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={etMartechGoldWinner}
                                                      alt="Comsense team member with the two ET Martech+ 2026 Gold awards"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Comsense Technologies received two Gold awards at the ET
                                              Martech+ 2026 Awards for its work with Royal Enfield across
                                              two distinct MarTech use cases:
                                              <br />
                                              <br />
                                              1){" "}
                                              <strong>
                                                Use of MarTech for Customer Retention & Loyalty
                                              </strong>
                                              , for the Service Leads and RFM use case.
                                              <br />
                                              2){" "}
                                              <strong>
                                                Use of MarTech for Location-Based Marketing Campaigns
                                              </strong>
                                              , for the Weather API use case.
                                              <br />
                                              <br />
                                              The two recognitions highlight different applications of
                                              MarTech, from strengthening customer retention to creating
                                              more contextual, location-based experiences. Both initiatives
                                              demonstrate how data and technology can be applied to address
                                              specific customer engagement objectives.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


    
       

          {/*  */}

          <layout label="1/1 content">
            <table
              className="full"
              align="center"
              bgcolor="#333742"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={25} />
                                </tr>

                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Tech Trends 
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{
                                      fontFamily: "Open sans,arial,sans-serif",
                                      fontSize: 18,
                                      color: "red",
                                      lineHeight: "28px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                    }}
                                  >
                                    Technology Lens: From Many Channels to One
                                    Conversation
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td>
                                    <table
                                      width={150}
                                      className="table-full"
                                      border={0}
                                      align="left"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              src={nehaKushwaha}
                                              width={150}
                                              alt="Neha Kushwaha, Senior Manager - MarTech"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: "5px solid #eaecf0",
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                    {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                    <table
                                      width={25}
                                      align="left"
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                      </tbody>
                                    </table>
                                    {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                    <table
                                      className="table-full"
                                      width={375}
                                      border={0}
                                      align="right"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={120} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              border: "0 solid #fff",
                                              borderRadius: 4,
                                            }}
                                          >
                                            <table
                                              width="90%"
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    valign="bottom"
                                                    style={{
                                                      fontFamily:
                                                        "Century gothic,arial,sans-serif",
                                                      fontSize: 24,
                                                      color: "#4a4a4a",
                                                      fontWeight: 100,
                                                      lineHeight: "30px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <p
                                                      style={{
                                                        color: "#000",
                                                        fontFamily:
                                                          "Century Gothic",
                                                        fontSize: 14,
                                                        fontStyle: "normal",
                                                        fontWeight: 400,
                                                        lineHeight: "normal",
                                                        marginBottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        style={{
                                                          color: "#000",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        - Neha Kushwaha, Senior
                                                        Manager - MarTech
                                                      </span>
                                                    </p>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td align="left">
                                                    <table
                                                      align="left"
                                                      width={30}
                                                      border={0}
                                                      cellSpacing={0}
                                                      cellPadding={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            height={10}
                                                            style={{
                                                              borderBottom:
                                                                "3px solid red",
                                                            }}
                                                          />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={10} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          

          {/* Tech Trends */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                Technology Lens: From Many
                                                Channels to One Conversation
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Ask any marketing team which channels they run and the list is long: Email, SMS, WhatsApp, Push, RCS, Meta, Google. Now ask how those channels talk to each other, and the room usually goes quiet.
                                              <br />
                                              <br />
                                              That’s the real gap in Martech today. Most brands have already bought the channels. What they haven’t built is the connection between them. Each channel runs on its own calendar, its own audience list and its own report. The email team celebrates an open rate, the SMS team watches delivery, and the paid media team chases ROAS. The customer sees one brand and gets five unrelated conversations.
                                              <br />
                                              <br />
                                              <strong>Silence is a signal</strong>
                                              <br />
                                              Take a customer who hasn’t opened your last ten emails. In most setups, the ten and first email goes out anyway. Meanwhile, that same person is on Instagram every day and replies to WhatsApp messages within minutes. They didn’t stop being interested. You were just talking on the wrong channel.
                                              <br />
                                              <br />
                                              Non engagement on one channel is not a dead end. It tells you where <i>not</i> to look next. The same goes for engagement. Someone who opened an email and clicked a product but didn’t buy is a warm lead. They deserve a nudge on WhatsApp or a reminder on Meta showing that exact product, not another generic broadcast.
                                              <br />
                                              <br />
                                              <strong>What joined up looks like</strong>
                                              <br />
                                              Three shifts make the difference.
                                              <br />
                                              <br />
                                              <strong>Start from the customer, not the channel.</strong> One view of the customer, built on first party data, should decide who gets what and where. Channels become routes to the person, not separate audiences.
                                              <br />
                                              <br />
                                              <strong>Use engagement as an input.</strong> What a customer does on one channel should trigger the next step on another. Email non openers move to SMS or WhatsApp. Clickers who didn’t convert go into a retargeting audience. Buyers get suppressed from promotions, which also saves spend.
                                              <br />
                                              <br />
                                              <strong>Treat paid and owned as one system.</strong> Meta and Google shouldn’t sit outside the CRM conversation. Syncing CRM audiences to paid platforms lets you retarget engaged but not converted users, exclude recent buyers, build lookalikes from your best customers, and reach lapsed customers who’ve stopped responding to owned channels. It also works in reverse because ad engagement can feed back into CRM journeys.
                                              <br />
                                              <br />
                                              <strong>A use case from the field</strong>
                                              <br />
                                              We saw a version of this with a leading global sportswear brand. Their database held well over a million buyers from the previous year who hadn’t purchased since. Plenty of data, plenty of channels, but no real plan to bring these customers back.
                                              <br />
                                              <br />
                                              We ran a churn reactivation pilot as a controlled test. Instead of one big blast, we ran multi-wave campaigns across email, SMS and push, with each wave informed by what happened in the last. We tested different mechanics too: a dynamic category level offer early on, a sale led push mid-year, and a small additional coupon during the sale to nudge the fence sitters. Running was the lead category, so messaging followed what these customers had actually bought before.
                                              <br />
                                              <br />
                                              Thousands of dormant buyers came back, and the revenue they generated was substantial for a pilot. Open and click rates also came in above the brand’s regular campaigns. The biggest lesson was that no single channel or offer did the work. The results came from sequencing: who got which message, on which channel, and after what behaviour. We saw the same pattern elsewhere. When RCS was pointed at audiences that had gone quiet on other channels, it performed noticeably better than expected.
                                              <br />
                                              <br />
                                              The obvious next step is to bring paid media into the loop. That means pushing the lapsed and engaged but not converted cohorts to Meta and Google, so the customer who ignores the inbox still sees a relevant product on their feed. That is where the pilot is headed.
                                              <br />
                                              <br />
                                              <strong>Where to begin</strong>
                                              <br />
                                              You don’t need to rebuild your stack. Start with three questions:
                                              <br />
                                              1) If a customer ignores us on one channel, what happens next?
                                              <br />
                                              2) Do our paid audiences know what our CRM already knows?
                                              <br />
                                              3) Do we know each customer’s preferred channel, and are we actually using it?
                                              <br />
                                              <br />
                                              If the honest answers are “nothing,” “no” and “not really,” you’ve found your biggest growth opportunity. It’s likely already sitting in your database.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={60} />
                                        </tr>
                                        
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

           <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “The three ordinary things that we often don't pay enough attention to, but which I believe are the drivers of all success, are hard work, perseverance, and basic honesty.”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Azim Premji
                                                        </span>{" "}
                                                        (CEO of Alphabet & Google)
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={azimPremji}
                                                      alt="Azim Premji"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={15} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

    

          {/* Associate Speak */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Associates Speak 
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td align="center">

                                            <table
                                              className="table-inner"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                            }}
                                                          >
                                                            <img
                                                              src={sayliAtkare}
                                                              alt="Sayli Atkare, Account Manager"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                      

My journey with <strong>Comsense Technologies</strong> has been a great learning experience, providing opportunities for professional growth, cross-functional collaboration, and continuous development. 
                                                              <br />
                                                              <br />
What sets Comsense apart is its customer-centric approach, strong technology expertise, and focus on delivering measurable business outcomes. The collaborative culture and ownership-driven environment have helped me strengthen my strategic thinking, stakeholder management, and problem-solving skills.
                                                              <br />
                                                              <br />
                                                              Proud to be part of a team that drives digital transformation and creates lasting value for its customers. 
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Sayli Atkare,
                                                                </strong>{" "}
Account Manager
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>



                                            <table
                                              className="table-inner desktop-view"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
My experience with the company so far has been really positive. The team leads have been very supportive and approachable, always guiding me whenever I need help or clarity. Task management and coordination have been good, which helps maintain a clear understanding of priorities and responsibilities. 
                                                              <br />
                                                              <br />
One of the things I appreciate most is the learning scope. I get opportunities to explore new technologies, improve my technical skills, and gain practical experience through the work I do. The healthy and friendly work environment also makes it comfortable to ask questions, share ideas, and learn from others. 
                                                              <br />
                                                              <br />
 Overall, I appreciate the support, teamwork, and opportunities the company provides for professional growth. It has been a good learning experience so far, and I look forward to continuing to learn, contribute, and grow with the organization. 
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Sony Petkar,
                                                                </strong>{" "}
                                                                Trainee Software Engineer
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={30} />
                                                        </tr>
                                                        <tr>
                                                          <td height={5} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={sonyPetkar}
                                                              alt="Sony Petkar, Trainee Software Engineer"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={45} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner mobile-responsive"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={sonyPetkar}
                                                              alt="Sony Petkar, Trainee Software Engineer"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              an excellent
                                                              place for
                                                              continuous
                                                              learning and
                                                              professional
                                                              growth. What I
                                                              value most is the
                                                              supportive team
                                                              and the
                                                              collaborative
                                                              work culture. The
                                                              guidance and
                                                              encouragement
                                                              from our
                                                              leadership
                                                              inspire us to
                                                              learn, take on
                                                              new challenges,
                                                              and keep
                                                              improving.
                                                              <br />
                                                              <br />
                                                              The open and
                                                              inclusive culture
                                                              at Comsense
                                                              allows us to
                                                              connect with
                                                              different teams,
                                                              share ideas, and
                                                              explore new
                                                              opportunities
                                                              without
                                                              limitations.
                                                              This environment
                                                              has helped me
                                                              grow both
                                                              personally and
                                                              professionally.
                                                              <br />
                                                              <br />
                                                              More than just a
                                                              workplace,
                                                              Comsense feels
                                                              like a family
                                                              where everyone is
                                                              valued and
                                                              supported. I am
                                                              proud to be a
                                                              part of Comsense
                                                              and truly
                                                              grateful for the
                                                              opportunity to
                                                              contribute to its
                                                              journey.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Sony Petkar,
                                                                </strong>
                                                                {""} Trainee Software Engineer
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>


                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td align="center"></td>
                                                </tr>
                                                
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


           <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Words That Inspire
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width="100%"
                                      style={{ maxWidth: 500 }}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width="100%"
                                              style={{ maxWidth: 500 }}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr className="quote-card-row">
                                                  <td
                                                    width="75%"
                                                    valign="bottom"
                                                    className="quote-card-text"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “My childhood was not a world of “Great job!” It was more like “That was so-so” or “Is this the best you can do?” We were accustomed to honesty, not false encouragement.”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Indra Nooyi (Former CEO - PepsiCo)
                                                        </span>{" "}
                                                       
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width="5%"
                                                    className="quote-card-gutter"
                                                  >
                                                    &nbsp;
                                                  </td>
                                                  <td
                                                    width="20%"
                                                    valign="bottom"
                                                    align="center"
                                                    className="quote-card-image"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={indraNooyi}
                                                      alt="indra Nooyi, Former CEO - PepsiCo"
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        maxWidth: 100,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={35} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

  

          
          {/* Welcome Aboard */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={newJoinersQ2}
                                              alt="Welcome Aboard - New joiners at Comsense Technologies: Sony Petkar, Pranjali Gujar, Saurabh Wabale, Tijo Varughese, Bishlesha Khandelwal, Kanchan Yadav, Devendra Kathar, Pragati Golhar, Snehal Gulhane, Priyanka Devi"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
Last quarter marked another exciting phase of growth for Comsense Technologies as we welcomed new members to our company, namely Rutuja Surve, Ketaki Pawar, Yadni Desai, Neha Singh, and Vishal Bawane.
                                              <br />
                                              <br />
We are thrilled to have them with us and look forward to achieving great things together. 
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Events and Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Events & Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
Annual Trip to Unwind Together 
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={annualDay}
                                                      alt="annual trip to unwind together - Comsense team outing in Mahabaleshwar"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={annualDayTeam}
                                                      alt="annual trip to unwind together - Comsense team outing in Mahabaleshwar"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
The Comsense team came together for its annual outing, taking a break from the usual work routine to unwind and spend time together in Mahabaleshwar. The day included team-bonding games, friendly competition, and plenty of laughter. A special moment was the presentation of the Leadership Award to Umang Varshney, recognizing his initiative, ownership, and positive contribution to the team. 
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
Celebrating Independence Day at Comsense 
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="32%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "250px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={independenceDayCelebrations}
                                                      alt="independence Day celebrations at Comsense - Chair Yoga Session"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="32%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "250px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={independenceDayCelebrationstwo}
                                                      alt="Independence Day Celebrations at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                       
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
Comsense celebrated Independence Day with the team dressed in the colours of the Indian tricolour. The office was also decorated in the spirit of the occasion, creating a festive atmosphere as everyone came together to mark the day. 
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
Celebrating Ganpati Chaturthi
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={ganpatiCelebrations}
                                                      alt="Ganpati Chaturthi Celebrations at Comsense"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                      }}
                                                      src={ganpatiCelebrationsPeople}
                                                      alt="Ganpati Chaturthi Celebrations at Comsense"
                                                      width="100%"
                                                      height="auto"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
The Comsense team celebrated Ganpati Chaturthi with a traditional day at the office. Dressed in traditional attire, colleagues came together for fun games and festive activities. The celebration concluded on a sweet note with everyone enjoying delicious modaks. 

 
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Grand Birthday Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Grand Birthday Celebrations
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td width={580} align="center">
                                            <table
                                              width="100%"
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={
                                                        grandBirthdayCelebrations1
                                                      }
                                                      alt="Grand Birthday Celebrations at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                  <td width="2%">&nbsp;</td>
                                                  <td
                                                    width="49%"
                                                    valign="top"
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                        width: "100%",
                                                        height: "260px",
                                                        objectFit: "cover",
                                                      }}
                                                      src={
                                                        grandBirthdayCelebrations2
                                                      }
                                                      alt="Grand Birthday Celebrations at Comsense"
                                                      width="100%"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
 

Birthdays are reasons for special celebrations, and the previous quarter gave us plenty of them. The last quarter was fun-filled as we celebrated birthdays of: 

 
                                              <br />
                                              <br />
Neha Kushwaha, Wasim Miya, Rohit Badave, Umesh Kolate, Abhishek Deshpande, 

Shubham Bhosekar, Dipali More, Rakhi Ankar, Shubham Kadam, Abhishek Sontakke, Rohit Deshmukh, Rutuja Rajput, Rupesh Bhosale, Shubham Wavare, Revati Vidhale, Pranav Konde, Dhanshri Bhawar, Arpita Dhumal, Saurabh Kushwaha, Aparna Tripathi, Shalini Tiwari, Shreya Mankar, Nivesh Surana, Aditya Somani, Gaurav Patil, Vishal Kadu, Snehal Gulhane, Pragati Golhar, Ketaki Pawar, Yadni Desai, Neha Singh.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>


          {/* Spiritual Corner */}
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="title">
                                      Spiritual Corner
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={300}
                                      className="table-full"
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                           <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={spiritualCornerChariji}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                     
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                               
                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 16,
                                      color: "#9b9b9b",
                                      lineHeight: "28px",
                                      fontWeight: 600,
                                    }}
                                  >
                                    <multiline label="quote">
                                      
Heartificial Intelligence 

                                    </multiline>
                                  </td>
                                </tr>
                                                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
 

Dear friends, 

 
                                              <br />
                                              <br />
Artificial Intelligence has become part of our everyday lives, helping us with everything from research and budgeting to writing and information discovery. But AI also has its limitations. It depends largely on existing, digitized information, which can be incomplete, culturally biased, or incorrect. 

 <br /><br />
 There is another form of intelligence: <strong>Heartificial Intelligence</strong>. 

It is the ability to access wisdom through the human heart, beyond the limitations of data, technology, language, and culture. 
<br /><br />
All of us can access it by preparing our hearts through <strong>meditation, mental purification, and connection with the center of our being.</strong> 

 <br /><br />
 A few minutes, three times a day, can create the space to receive this deeper wisdom. 

 
 
                                            </multiline>
                                          </td>
                                        </tr>
 <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="left"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "22px",
                                    }}
                                  >
                                    <multiline label="content">
                                      <strong> Click here to read the full letter by Daaji:</strong>{" "}
                                        <a
                                          href="https://www.daaji.org/heartificial-intelligence"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#9b9b9b",
                                            fontFamily: "Open Sans",
                                            fontSize: 14,
                                            fontWeight: 700,
                                            lineHeight: "22px",
                                            textDecorationLine: "underline",
                                          }}
                                        >
                                          https://www.daaji.org/heartificial-intelligence
                                        </a>
                                      </multiline>
                                  </td>
                                </tr>
                                                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
 

Warm regards,
 <br />
Kamlesh 

 

 
 
                                            </multiline>
                                          </td>
                                        </tr>
 
                                <tr>
                                  <td height={30} />
                                </tr>
                                <tr>
                                  <td
                                    align="left"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "22px",
                                    }}
                                  >
                                    <multiline label="content">
                                     
                                        <a
                                          href="https://www.heartfulness.org/"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{
                                            color: "#9b9b9b",
                                            fontFamily: "Open Sans",
                                            fontSize: 14,
                                            fontWeight: 700,
                                            lineHeight: "22px",
                                            textDecorationLine: "underline",
                                          }}
                                        >
More about Heartfulness: www.heartfulness.org 
                                        </a>
                                    </multiline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                 <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

        
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default September2026;
